import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from '../shared/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CarouselModule } from 'primeng/carousel';
import { NgImageSliderModule } from 'ng-image-slider';
import { PanelModule } from 'primeng/panel';
import { RatingModule } from 'primeng/rating';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { CollaborationSchoolComponent } from './collaboration-school/collaboration-school.component';
import { CollaborationSchoolRoutingModule } from './collaboration-school-routing.module';
import { AmyTooltipModuleModule } from '../amy-tooltip-module/amy-tooltip-module.module';
import { CollaboationSchoolGroupComponent } from './collaboation-school-group/collaboation-school-group.component';
import { CollaborationSchoolViewTutorialComponent } from './collaboration-school-view-tutorial/collaboration-school-view-tutorial.component';



@NgModule({
  declarations: [
    CollaborationSchoolComponent,
    CollaboationSchoolGroupComponent,
    CollaborationSchoolViewTutorialComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    NgImageSliderModule,
    PrimengModule,
    FormsModule,
    TranslateModule,
    PanelModule,
    CarouselModule,
    RatingModule,
    AvatarModule,
    AvatarGroupModule,
    AmyTooltipModuleModule,
    CommonComponentsModule,
    CollaborationSchoolRoutingModule
  ]
})
export class CollaborationSchoolModule { }
